import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import quest from '../assets/icons/quest.svg';

const FeedbackButton = ({ onGuideClick }) => {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  
  // Get the current page name from the URL path
  const pageName = location.pathname.split('/').filter(Boolean).join(' ') || 'Home';
  const language = i18n.language === 'ar' ? 'Ar' : 'En'; // Adjust language code based on the current language
  
  const feedbackUrl = `https://surveys.geoportal.sa/share/21ac241e039948a5b720b4d1131fb41d?field:pagename=${encodeURIComponent(pageName)}&locale=${language}`;
  const QuestUrl = `https://dxmisurvey.my.gov.sa/survey/p/steps/1/4dfc4166-f5fa-4743-80f2-08dd4f6aa420/register`;
  
  // Check if the current page is the homepage or geocatalog
  const isHomepage = location.pathname === '/';
  const isGeocatalog = location.pathname === '/national-geocatalog';

  return (
    <div>
      <div className="fixed-buttons">
        {/* Feedback Button */}
        <a href={feedbackUrl} target="_blank" rel="noopener noreferrer">
          <button className="btn btn-primary guide-btn">
            <svg className="svg" fill="currentColor" height="100%" viewBox="0 0 16 16" width="100%" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 15H3V3h1v1h8V3h1l1-.999L12 2V1H9.723a1.984 1.984 0 0 0-3.446 0H4v1H2v14h12V7.899l-1 1zM5 2h2v-.318A.682.682 0 0 1 7.682 1h.636A.682.682 0 0 1 9 1.682V2h2v1H5zm9.646 1.646l.707.707L9.5 10.207 7.046 7.754l.707-.707L9.5 8.793z"></path>
            </svg>
          </button>
        </a>
      </div>

      {/* Second Button on the Left 
      <div className="second-button">
      <a href={QuestUrl} target="_blank" rel="noopener noreferrer">

        <button className="btn btn-secondary guide-btn2">
<img src={quest} alt="Quest Button" className='svg-icon'/>        </button>
        </a>
      </div>*/}
    </div>
  );
};

export default FeedbackButton;
